//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

  import {mapState, mapMutations} from 'vuex'
  import {cartInfo, orderPlace, updateCart, getCartNum, campaignRule,userInfo} from '@/service/index'
  import countryData from './data'
  import Config from '@/utils/global.js'

  import GUI from './modal/GUINumber.vue'

  export default {
    components: {
      GUI
    },
    data() {
      return {
        addressVisible: false,
        lastName:'',
        firstName:'',
        countryData:countryData,
        address:'',
        mobile:'',
        SubmitLoading:false,
        selectedAddress:'',
        multipleSelection: [],
        selectedOptions:[],
        centerDialogVisible: false,
        deleteVisible: false,
        selectedDeletePro: {},
        total: 0,
        allQty: 0,
        selectAll: false,
        cartInfoList: [],
        rule: {},
        isLoading:true,
        point:null,
        points:null,

        GUIVisible:false,
        other: ''
      }
    },
    computed: {
      ...mapState([
        'global', 'categories', 'campaign', 'bread', 'goods','specName','specNameEn'
      ]),
      specNames(){
         return  this.$i18n.locale  === 'en' ? this.specNameEn : this.specName;
      }
    },
    methods: {
      ...mapMutations({
        initCartNum: 'INIT_CART_NUM',
      }),
      async getUserInfo () {
        const res = await userInfo(this.$route.query.cid)
        if (res.status === 0) {
          this.point = res.data.point
          this.points = res.data.points
//          this.recordUserinfo(res.data)
        }
      },
      clearFocus(self){
        window.document.activeElement.blur()
      },
      goToDetails(productId) {
        this.$router.push({name: 'goodDetail', query: { id: productId, cid: this.$route.query.cid } });
      },
      toggleSelection(rows) {
        if (rows && !this.selectAll) {
          this.selectAll = true;
          rows.forEach(row => {
            this.$refs.multipleTable.toggleRowSelection(row, true);
          });
        } else if(!this.selectAll){
          this.selectAll = true;
          for (let i = 0; i < this.cartInfoList.length; i++) {
            this.$refs.multipleTable.toggleRowSelection(this.cartInfoList[i], true);
          }
        }else {
          this.selectAll = false
          this.$refs.multipleTable.clearSelection();
        }
      },
      handleSelectionChange(val) {
        this.multipleSelection = val;
        this.total = 0;
        this.allQty = 0;
        val.forEach(item => {
          this.total = this.total + parseFloat(item.price) * parseInt(item.qty);
          this.allQty += item.qty;
        })
      },
      async changeCount(row) {
        const param = {};
        param.items = [];
        param.items.push({
          qty: row.qty,
          productId: row.productId
        })
        const res = await updateCart(this.$route.query.cid, param)
        if (res.status === 0) {
          this.total = 0;
          this.allQty = 0;
          this.$refs.multipleTable.selection.forEach(item => {
            this.total = this.total + parseFloat(item.price) * parseInt(item.qty);
            this.allQty += item.qty;
          })
          const cartRes = await getCartNum(this.$route.query.cid)
          this.initCartNum({cartNum: cartRes.data})
        }else {
          row.qty = row.qty - 1;
          if (res.status === 2) {
            this.$message(this.$t("cartMsg.lackall"));
          } else if (res.status === 3) {
            this.submitFlag = false
            this.$message(this.$t("cartMsg.lackall"));
          } else if (res.status === 4) {
            this.submitFlag = false
            this.$message(this.$t("cartMsg.globalamount"));
          } else if (res.status === 5) {
            this.submitFlag = false
            this.$message(this.$t("cartMsg.perskuqty"));

          } else if (res.status === 6) {
            this.submitFlag = false
            this.$message(this.$t("cartMsg.globalqty"));

          } else if (res.status === 7) {
            this.submitFlag = false
            this.$message(this.$t("cartMsg.typeqty"));

          } else if (res.status === 8) {
            this.submitFlag = false
            this.$message(this.$t("cartMsg.catqty"));

          } else if (res.status === 9) {
            this.submitFlag = false
            this.$message(this.$t("cartMsg.orderqty"));

          } else if(res.status === 10){
            this.submitFlag = false
            this.$message(this.$t("cartMsg.pointlack"));
          } else if(res.status === 11){
            this.submitFlag = false
            this.$message(this.$t("cartMsg.personalamount"));
          }else {
            this.submitFlag = false
            this.$message(this.$t("cartMsg.retry"));
          }
        }
      },
      handleChange(){

      },
      submitData() {
        // this.$confirm('一个人只有' + this.rule.orderQty + '次下单机会，一经付款，订单就不可取消和修改，您依然确定要下单吗？', '提示', {
        //   confirmButtonText: '确定',
        //   cancelButtonText: '取消',
        //   type: 'warning'
        // }).then(() => {
        //   const id = this.orderPlace(this.multipleSelection);
        // }).catch(() => {
        // });

        //--------old---------//
        // if(Config.needAddress){
        //   this.addressVisible = true
        // }else{
        //    if(this.rule.orderQty<0||this.rule.orderQty>=20) {
        //       this.orderPlace();
        //       return
        //     }
        //     this.centerDialogVisible = true;
        // }
        //--------old---------//

        this.GUIVisible = true
        // if(this.rule.orderQty<0||this.rule.orderQty>=20) {
        //     this.orderPlace();
        //     return
        // }
        // this.centerDialogVisible = true;
      },
      onConfirmAddCart(val){
        this.other = val
        if(Config.needAddress){
          this.addressVisible = true
        }else{
           if(this.rule.orderQty<0||this.rule.orderQty>=20) {
              this.orderPlace();
              return
            }
            this.centerDialogVisible = true;
        }
      },
      submitFilter(data) {
        return data / 1 === 0;
      },
      goBack() {
//        goback可能不存在
        this.$router.push({
          path: `/home/${this.$route.query.cid}`,
          query:{ cid: this.$route.query.cid }
        })
      },
      async getCartInfo() {
        const res = await cartInfo(this.$route.query.cid);
        this.isLoading=false
        if (res.status === 0) {
          this.cartInfoList = res.data
          this.$nextTick(function(){
            this.toggleSelection()
          })
        }
      },
      async getCampaignRuleInfo() {
        const res = await campaignRule(this.$route.query.cid);
        if (res.status === 0) {
          this.rule = res.data
        }
      },


       onSubmitData() {
        //var myreg=/^[1][3,4,5,6,7,8,9][0-9]{9}$/;

        if (!this.lastName) {
          this.$message(this.$t("cartMsg.lastName"));
        } else if (!this.firstName) {
          this.$message(this.$t("cartMsg.firstName"));
        } else if (!this.mobile) {
          this.$message(this.$t("cartMsg.correctmobile"));
        }else if (this.selectedOptions.length==0) {
          this.$message(this.$t("cartMsg.District"));
        } else if(this.selectedAddress == ''){
          this.$message(this.$t("cartMsg.address"));
        }else {
          //console.log('this.selectedOptions',this.selectedOptions)
          this.address=this.getCountry(this.selectedOptions)+' '+ this.selectedAddress
          
          if (this.rule.orderQty === -1 || this.rule.orderQty === 100000) {
            this.orderPlace()
          } else {
            this.centerDialogVisible = true;
          }
        }
      },


      async orderPlace() {
        this.centerDialogVisible = false
        this.addressVisible = false
        const param = {};
        param.items = [];
        this.SubmitLoading=true
        if(this.other){
          param.gui = this.other
        }
         if(Config.needAddress){
           if (this.address != '') {
              param.address = this.address
            }



            param.firstName=this.firstName
            param.lastName=this.lastName
            param.mobile=this.mobile


         }

        

        // const param = {};
        // param.items = [];
        this.multipleSelection.map(item => {
          param.items.push({
            productId: item.productId,
            qty: item.qty
          })
        })
        const res = await orderPlace(this.$route.query.cid, param);
        this.SubmitLoading=false
        if (res.status === 0) {
          this.$router.push({
            path: `/orderDetail/${res.data.order.id}`,
            query: {cid: this.$route.query.cid}
          })
          const cartRes = await getCartNum(this.$route.query.cid)
          this.initCartNum({cartNum: cartRes.data})
        } else if (res.status === 2) {
          this.$message(this.$t("placeorder.lack"));
          const obj = this;
          setTimeout(
            function () {
              obj.$router.push({
              path: `/orderDetail/${res.data.order.id}`,
              query: {cid: obj.$route.query.cid}
            });
          }, 3000)
          const cartRes = await getCartNum(this.$route.query.cid)
          this.initCartNum({cartNum: cartRes.data})
        } else if (res.status === 3) {
          this.$message(this.$t("placeorder.lackall"));
        } else if (res.status === 4){
          this.$message(this.$t("placeorder.globalamount"));
        } else if (res.status === 5){
          this.$message(this.$t("placeorder.perskuqty"));
        } else if (res.status === 6){
          this.$message(this.$t("placeorder.globalqty"));
        } else if (res.status === 7){
          this.$message(this.$t("placeorder.typeqty"));
        } else if (res.status === 8){
          this.$message(this.$t("placeorder.catqty"));
        } else if (res.status === 9) {
          this.$message(this.$t("placeorder.orderqty"));
        } else if(res.status === 10){
          this.$message(this.$t("placeorder.pointlack"));
        } else if(res.status === 11){
          this.$message(this.$t("placeorder.personalamount"));
        }else {
          this.$message(this.$t("placeorder.retry"));
        }
      },
      selectDelete(item){
        this.deleteVisible = true
        this.selectedDeletePro = item;
      },
      keepLang(){
        let locale = localStorage.locale;
        this.$i18n.locale = locale === 'en' ? locale : 'zh';
      },
      async deletePro() {
        this.deleteVisible = false;
        const param = {};
        param.items = [];
        param.items.push({
          qty: 0,
          productId: this.selectedDeletePro.productId
        })
        const res = await updateCart(this.$route.query.cid, param)
        if (res.status === 0) {
          this.$message({
            message: 'Success',
            type: 'success'
          })
          const cartRes = await getCartNum(this.$route.query.cid)
          this.initCartNum({cartNum: cartRes.data})
          this.getCartInfo()
        }
      },
      getCountry(selected){
        //console.log('selected',selected)
        let _country=''
        countryData.forEach((item)=>{
         if(selected[0]==item.value){
           _country+=item.label

          item.children.forEach((citem)=>{
            if(selected[1]==citem.value){
              _country+=' '+citem.label
            }
            if(citem.children){
                 citem.children.forEach((ditem)=>{
                  if(selected[2]==ditem.value){
                    _country+=' '+ditem.label
                  }
                 })

            }




          })

         }
        //  this.CodeToText[item.value] = item.label
        //  item.children.forEach((citem)=>{
        //    console.log(citem.value)
        //    this.CodeToText[citem.value] = citem.label
        //  })
      })
       return _country
      }
    },
    mounted() {
      this.getUserInfo();
      this.getCartInfo();
      this.getCampaignRuleInfo();
      this.keepLang();
    },

  }



// WEBPACK FOOTER //
// ./src/pages/cart/CartPc.vue